<template>
  <h1>{{ $filters.i18n('greet') }}</h1>
</template>

<script>
export default {
  name: 'Home'
}
</script>
